module.exports = __webpack_public_path__ + "img/Nav_Unfold_Light.4c95e866.svg";